import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { countriesCodes } from 'helpers/usStates';
import {
  Typography,
  Grid,
  Select,
  Button,
  MenuItem
} from '@material-ui/core';
import { editCustomerSubscriptionBillingInfoApi } from 'api';


const PaymentInfo = ({customerSubscriptionBillingInfo, goBackPath}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {id} = useParams<{ id: string }>();
  const [paymentAccount, setPaymentAccount] = useState(customerSubscriptionBillingInfo?.active_card);
  const { address } = customerSubscriptionBillingInfo;

  const handleChangePaymentCard = (e) => {
    setPaymentAccount(e.target.value);
  };

  const handleSavePaymentCard = () => {
    editCustomerSubscriptionBillingInfoApi({dispatch, id, token: paymentAccount});
  };

  return (
    <div className="py-6 px-2 mt-4">
      <Grid container spacing={2} className="flex items-center">
        <Grid container xs={12} sm={6}>
          <Grid item xs={12}>
            <Typography className="mb-4">
              This payment record will be used for future payments. Any changes will take effect on the next billing.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className="mb-2" variant="h6">
              Payment Account
            </Typography>
            <Select
              fullWidth
              variant="outlined"
              name="frequency_unit"
              className="mb-2"
              value={paymentAccount}
              onChange={(e) => handleChangePaymentCard(e)}
            >
              {customerSubscriptionBillingInfo?.cards?.map((el) => (
                <MenuItem key={el.token} value={el.token}>{el.card}</MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12}>
            <Typography className="mb-2 mt-4" variant="h6">
              Billing Address
            </Typography>
            <div className="ml-2 mb-2">
              <Typography>
                {`${address?.firstname} ${address?.lastname}`}
              </Typography>
              {address?.street.map((str) => (
                <Typography
                  key={str}
                >
                  {str}
                </Typography>
              ))}
              <Typography>
                {`${address?.city}, ${address?.region?.region} ${address?.postcode}`}
              </Typography>
              <Typography>
                {countriesCodes[address?.country_id]}
              </Typography>
              <Typography>
                T: {address?.telephone}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className="mt-4"
        onClick={handleSavePaymentCard}
      >
        Save Subscription
      </Button>
      <Button
        variant="outlined"
        color="primary"
        className="mt-4 ml-2"
        onClick={() => history.push(goBackPath)}
      >
        Go Back
      </Button>
    </div>
  );
};

export default PaymentInfo;
